"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootBoxInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const LootBoxInput = () => {
    const contractId = (0, react_hook_form_1.useWatch)({ name: "contractId" });
    const lootId = (0, react_hook_form_1.useWatch)({ name: "lootId" });
    const form = (0, react_hook_form_1.useFormContext)();
    const handleChange = (_event, option) => {
        form.setValue("lootBox", option, { shouldDirty: true });
        form.setValue("lootId", option?.id ?? 0, { shouldDirty: true });
    };
    (0, react_1.useEffect)(() => {
        if (!lootId) {
            form.setValue("lootBox", null);
        }
    }, [lootId]);
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { required: true, name: "lootId", controller: "loot/boxes", onChange: handleChange, fetchData: { contractIds: [contractId] }, autoSelect: true, disableClear: true }));
};
exports.LootBoxInput = LootBoxInput;
//# sourceMappingURL=index.js.map